import { RouterView, type RouteRecordRaw } from "vue-router";
import { ROUTE_NAME } from "@/shared/constants/routes";
import { h } from "vue";

export const routes: RouteRecordRaw[] = [
  {
    path: "/communication/chat",
    name: ROUTE_NAME.CHAT_CHANNELS,
    component: { render: () => h(RouterView) },
    redirect: { name: ROUTE_NAME.CHAT_CHANNELS_LIST },
    children: [
      {
        path: "",
        name: ROUTE_NAME.CHAT_CHANNELS_LIST,
        component: () => import("./views/ChatView.vue"),
      },
    ],
  },
];
